import { useState } from "react";
import { PulseLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import { formatMinor } from "../Components/Reusable/CurrencyFormatter/CurrencyFormatter";

const StepOne = (props) => {
  const { t } = useTranslation("makeBooking");
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <div className="booking-portal-step-wrapper">
      <section>
        <div className="service-wrapper">




                  <div className="details-head" style={{marginLeft:"0.5rem"}}>
          <div className="details-titles">
            <h2 className="details-title">{t("stepOne.titles.chooseService")}</h2>
          </div>
        </div>







          <div className="service-list">
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{ marginTop: "2rem" }}>
              <PulseLoader
                color={"#333"}
                loading={props.services === "waiting"}
                size={25}
                aria-label={t("stepOne.status.loadingAria")}
                data-testid="loader"
              />
            </div>
          </div>
            {props.services === "waiting" ? null : (props.services === null || props.serviceDurations === null) ? (
              <div className="service-info">{t("stepOne.status.noServices")}</div>
            ) : (
              <div>
                {props.services.map((service, idx) => (
                  <div className="service-card" key={idx}>
                    <div className={`service-content ${openIndex === idx ? "service-content--expanded" : ""}`}>
                      <div className="service-thumb">
                        {service.filename ? (
                          <img
                            alt={t("stepOne.labels.serviceImageAlt")}
                            src={
                              process.env.REACT_APP_API_SERVICE_BASE_URL +
                              "image/" +
                              "ServiceImages/" +
                              service.filename
                            }
                            className="service-image"
                          />
                        ) : (
                          <span className="service-thumb__fallback" aria-hidden="true">
                            {service.name ? service.name.charAt(0).toUpperCase() : "?"}
                          </span>
                        )}
                      </div>

                      <div className="service-info">
                        <h3>{service.name}</h3>

                        <div className="service-meta">
                          <span className="service-meta__chip service-meta__chip--duration">
                            {
                              props.serviceDurations.filter((item) => item.value === service.duration)[0]
                                .label
                            }
                          </span>
                          <span className="service-meta__chip service-meta__chip--price">
                            {formatMinor(service.price, props.currency)}
                          </span>
                        </div>
                        {service.description !== "" && service.description !== null && service.description !== undefined ?
                        <button
                          className="toggle-btn"
                          onClick={() => toggle(idx)}
                          aria-expanded={openIndex === idx}
                        >
                          {openIndex === idx
                            ? `▲ ${t("stepOne.actions.lessInfo")}`
                            : `▼ ${t("stepOne.actions.moreInfo")}`}
                        </button>
                        : null
                        }


                        <div className={`description ${openIndex === idx ? "expanded" : ""}`}>
                          <p>{service.description}</p>
                        </div>
                      </div>

                      <div className="service-action">
                        <button
                          onClick={() => {
                            props.handleServiceSelected(service);
                            props.goTo(1);
                            props.getBarbers(service);
                          }}
                          className="select-btn"
                        >
                          {t("stepOne.actions.book")}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default StepOne;
